<template>
    <div class="loginbg">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <!-- <div class="form-group">
                                <label for="exampleInputEmail1">Email address</label>
                                <input v-model="username" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email address">
                                <font class="text-danger" v-html="usernameError"></font>
                                <div class="c-error">{{usernameError}}</div>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input v-model="password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Enter password">
                                <font class="text-danger" v-html="passwordError"></font>
                                <div class="c-error">{{passwordError}}</div>
                            </div>


                            <div class="c-error">{{error}}</div>
                            <div class="form-check">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input type="checkbox">
                                    <span class="checkbox-placeholder"></span>
                                    Remember me
                                </label>
                            </div>

                            <button v-on:click.prevent="login()" type="submit" class="btn btn-primary">Login</button>
                            <a :href="forgot_pass_url" target="_blank">Forgot password?</a> -->
                            <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    Logout from (<a style="float: none;" v-bind:href="ssoDomainUrl">{{ssoDomainUrl}}</a>),If You are not able to login please clear Cookies and login again.
                                    Please contact admin if you are still not able to Login.
                            </label>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {HTTP} from '../http-common';
    import EventBus from './event-bus';
    import moment from 'moment';

    Vue.use(VueGoodTable);

    var self;
    export default {
        name: 'Login',
        data() {
            return {
                username : '',
                password : '',
                error: '',
                // Frontend Errors
                usernameError : '',
                passwordError : '',
                forgot_pass_url: '',
                browserTimeZone : "",
                ssoDomainUrl: ''
            }

        },
        beforeMount: function () {
            self = this;
            self.ssoDomainUrl = process.env.VUE_APP_SSO_ROOT_URL;

            if(self.$route.query.redirect == "false") {
                // DO NOTHING
            } else {
                if(self.$route.query.token) {
                    window.localStorage.setItem("api_token", self.$route.query.token);
                    window.localStorage.setItem("username", self.$route.query.username);
                    
                    self.autoLoginUser(self.$route.query.username);
                } else {
                    var api_token = localStorage.getItem("api_token");
                    if(api_token == null) {
                        $(".loginbg").show();
                        window.location.href = process.env.VUE_APP_SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_API + '&slug=' + process.env.PROJECT_SLUG;
                    } else {
                        self.$router.push("/");
                    }
                }
            }
        },
        mounted: function () {
            self = this;

            // $("#exampleInputEmail1").on('keyup', function () {
            //     self.usernameError = '';
            // });
            // $("#exampleInputPassword1").on('keyup', function () {
            //     self.passwordError = '';
            // });
            // $("#exampleInputPassword1").on('change', function () {
            //     self.passwordError = '';
            // });
            $("input").keypress(function(e) {
              if (e.keyCode === 13) {
                if (e.target.id == "exampleInputEmail1" || e.target.id == "exampleInputPassword1") {
                  e.preventDefault();
                //   console.log("Enter Triggered");
                  self.login();
                }
              }
            });

            self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
            self.browserTimeZone = moment.tz.guess();
        },
        methods: {
            autoLoginUser: function (username) {
                var self = this;
                var config = {
                    headers: {Authorization: localStorage.getItem("api_token")}
                };
                var fields = {
                    'username': username,
                    'access_token': window.localStorage.getItem('api_token')
                };
                HTTP.post("autologinuser", fields)
                    .then(function (data) {
                        if (data.status == 200) {                            
                            localStorage.setItem("api_token", data.data.content.api_token);
                            localStorage.setItem("user_obj", JSON.stringify(data.data.content.user_obj));

                            var userObj = JSON.parse(localStorage.getItem("user_obj"));
                            if (userObj != null) {
                                EventBus.$emit('login-user-info', 
                                    userObj.username, 
                                    userObj.first_name, 
                                    userObj.last_name, 
                                    userObj.location_name, 
                                    userObj.will_call_location_name
                                );
                            }

                            self.$router.push("/");
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            validation: function () {
                var checked = true;

                if (!self.username) {
                    self.usernameError = "Email address Required.";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.username)) {
                    self.usernameError = 'Please Enter Valid Email address';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.password) {
                    self.passwordError = "Password Required.";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            login: function () {
                self.usernameError = '';
                self.passwordError = '';
                self.error = '';
                // self.validation();
                if (self.validation()) {
                    var data = {
                        username : self.username,
                        password : self.password,
                    }
                    HTTP.post('/login',data)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                window.localStorage.setItem('browserTimeZone', self.browserTimeZone);
                                window.localStorage.setItem("api_token", response.data.content.api_token);
                                window.localStorage.setItem("user_obj", JSON.stringify(response.data.content.user_obj));

                                let userCurrentLocation = JSON.parse(localStorage.getItem("user_obj"))['user_current_location'];
                                let current_location_view = "";

                                if (userCurrentLocation === "primary") {
                                    current_location_view = "front_end";
                                } else if (userCurrentLocation === "secondary") {
                                    current_location_view = "will_call";
                                }
                                window.localStorage.setItem("current_location_view", current_location_view);
                                //self.$router.push("/closeticket");
                                self.$router.push("/");

                                var userObj = JSON.parse(localStorage.getItem("user_obj"));
                                if (userObj != null) {
                                    EventBus.$emit('login-user-info', userObj.username, userObj.first_name, userObj.last_name, userObj.location_name, userObj.will_call_location_name);
                                }
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        })
                }
            },

        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue